import React from 'react';
import { NavLink } from 'react-router-dom';
import { motion } from 'framer-motion';

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
      delayChildren: 0.3
    }
  }
};

const itemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: { y: 0, opacity: 1, transition: { duration: 0.5, ease: "easeOut" } }
};

const imageVariants = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: { 
      opacity: 1, 
      scale: 1, 
      transition: { duration: 0.8, ease: "easeOut" } 
  },
  floating: {
      y: ["0%", "-5%", "0%"],
      transition: {
          duration: 4,
          ease: "easeInOut",
          repeat: Infinity,
      }
  }
};

const HeroSection = ({ subhead, name, myRole, myInfo, image }) => {
    return (
        <> 
        {/*=============== Home section ===============*/}
        <div className="container">
        <div className="grid grid-two-column" style={{alignItems: "center"}}>
                <motion.div 
                    className="section-hero-data"
                    variants={containerVariants}
                    initial="hidden"
                    animate="visible"
                >
                    <motion.p variants={itemVariants} className="hero-top-data text-gradient" style={{fontWeight: "bold"}}>{subhead}</motion.p>
                    <motion.h1 variants={itemVariants} className="hero-heading">
                        <span className='name text-gradient' style={{fontSize: "5rem", letterSpacing: "1px"}}>{name} <br /></span>
                        <span className='myrole' style={{color: "var(--text-color)"}}>{myRole}</span>
                    </motion.h1>
                    <motion.div variants={itemVariants} className="hero-para" style={{lineHeight: "1.8"}}>{myInfo}</motion.div>
                    <motion.button variants={itemVariants} className='btn hireme-btn'>
                        <NavLink to ="/contact">Hire Me</NavLink>
                    </motion.button>
                </motion.div>
                <div className="section-hero-img">
                    <motion.picture
                        variants={imageVariants}
                        initial="hidden"
                        animate={["visible", "floating"]}
                        style={{ display: "inline-block" }}
                    >
                        <img src={image} alt={name} className="hero-image-animated" />
                    </motion.picture>
                </div>
            </div>
        </div>
        </>
    )
}

export default HeroSection